import store from "@/store";
import { isTokenFromLocalStorageValid } from "@/auth/auth.service";

export const authGuard = async function (to, from, next) {
  const authRequired = to.matched.some((record) => record.meta.authRequired);
  if (authRequired) {
    if (store.getters["authModule/isAuthenticated"]) {
      next();
      return;
    } else if (await isTokenFromLocalStorageValid()) {
      next();
      return;
    }
    next("/login");
    return;
  }
  next();
};
